import React , { useState }from 'react'
import PersonalCareIcon from '../assets/images/search-blue-icon.svg' 
import LocationIcon from '../assets/images/location-blue-icon.svg'
import MobileFilterIcon from '../assets/images/filter-icon.svg'  
import MobileFilterCloseIcon from '../assets/images/close-white.svg'
function FilterBox() {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };
  return (
    <>
    <section className={`filter-group ${isFilterVisible ? 'open' : ''}`}>
      <div className="container">
          <div className="filter-box">
          <form className="row align-items-center">
            <div className="col-auto col-lg-6">
                <div className="range-silder-box">
                  <label htmlFor="PersonalCare">Search Personal Care <sup>*</sup></label>
                  <div className='input-group'>
                    <img className="personal-care-img" src={PersonalCareIcon} alt="" />
                    <input
                      type="text"
                      id="PersonalCare"
                      name="personal_care"
                      placeholder='What are you looking for? ' 
                    />
                  </div>
                </div>
            </div>
            <div className="col-auto col-lg-4">
                <label htmlFor="LocationInput">Location <sup>*</sup></label>                
                <div className='input-group'>
                    <img className="location-img" src={LocationIcon} alt="" />
                    <input
                      type="text"
                      id="LocationInput"
                      name="location"
                      placeholder="City, State or Zipcode"
                      />
                  </div>
            </div>
            <div className="col-auto col-lg-2 search-btn-filter">
                <label>&nbsp;</label>
                <button
                type="submit"
                className="custom-bttn w-100 search-filter-bttn" 
                onClick={toggleFilterVisibility}
                >                
                Search
                </button>
            </div> 
          </form>
          </div>
      </div>
    </section>
    <a className="mobile-filter" href="#!" onClick={toggleFilterVisibility}><img src={isFilterVisible ? MobileFilterCloseIcon : MobileFilterIcon}
          alt={isFilterVisible ? 'Close Filter' : 'Open Filter'}/></a>
    </>
  )
}
export default FilterBox